export default {
  install (Vue) {
    Vue.prototype.$isToday = function (date) {
      if (!date) return false;
      const now = this.$moment().format('YYYYMMDD')
      const test = this.$moment(date).format('YYYYMMDD')
      return now === test
    }

    Vue.prototype.$strDate = function (date, strFormat = 'YYYY-MM-DD') {
      if (!date) return ''
      return this.$moment(date).format(strFormat)
    }

    Vue.prototype.$linebreak = function (data) {
      if (!data) return ''
      return data.replace(/\n/mg, () => '<br>')
    }

    Vue.prototype.$isTestDate = function (date) {
      if (!date) return false
      const now = this.$moment().format('YYYYMMDD');
      const test = this.$moment(date).format('YYYYMMDD');
      return now >= test
    }

    Vue.prototype.$isStuding = function (subject) {
      const now = this.$moment().format('YYYYMMDD'); // 오늘 날짜
      const startDate = this.$moment(subject.startDate).format('YYYYMMDD');
      const endDate = this.$moment(subject.endDate).format('YYYYMMDD');
      return now >= startDate && now <= endDate
    }

    Vue.prototype.$isEnd = function (subject) {
      const now = this.$moment().format('YYYYMMDD'); // 오늘 날짜
      const endDate = this.$moment(subject.endDate).format('YYYYMMDD');
      return now > endDate
    }

    Vue.prototype.$progress = function (startDate, endDate) {
      if (!startDate) return 0
      const now = this.$moment()
      const start = this.$moment(startDate)
      const end = this.$moment(endDate)
      const diff = ((now.diff(start, 'day') / end.diff(start, 'day')) * 100).toFixed(0)
      return Math.min(100, diff)
    }
  }
}
